import src from "IMAGE";
export default { src, width: 156, height: 64, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAPElEQVR42nWMOwoAMAhDXewnBERwFe9/y9qtSwNvCcmTiKC7w8z2S3e7qigkVT4BoJKZd639Gs1s1mPCAdTGBCYjrY6yAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 3 }
